import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../../components/Form/RadioBlock'
import CpaAdvancedSettings from '../CpaAdvancedSettings'
import TikTokPixelAndEventFields from '../../../../../../LineItemForms/LineItemTikTokCreate/LineItemTikTokCreateForm/Steps/PixelStep/TikTokPixelAndEventFields'

import { CLICK, CONVERT } from '../../../optimizationGoalOptions'
import { OPTIMIZATION_GOAL } from '../../../fields'
import {
  BID_PRICE,
  PIXEL_EVENT,
  PIXEL_ID
} from '../../../../../../LineItemForms/LineItemTikTokCreate/LineItemTikTokCreateForm/fields'
import { LEAD_GENERATION, WEB_CONVERSIONS } from '../../../../../../../../constants/campaigns'

const stepFields = [PIXEL_ID, PIXEL_EVENT, BID_PRICE]

const goalOptions = [
  { value: CONVERT, label: 'Conversion' },
  { value: CLICK, label: 'Clicks' }
]

const GoalsWithPixelAndEventStep = ({
  formik,
  handleStepChange,
  campaignObjective,
  showBidField,
  shouldPopulateExistingValues
}) => {
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const stepTitle = useMemo(() => {
    switch (campaignObjective.toLowerCase()) {
      case LEAD_GENERATION:
        return t('What is your lead goal?')
      case WEB_CONVERSIONS:
      default:
        return t('What is your web conversion goal?')
    }
  }, [campaignObjective, t])

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  if (!shouldPopulateExistingValues) {
    return (
      <Step stepTitle={stepTitle} handleContinue={handleContinue}>
        <RadioBlock
          setFieldValue={setFieldValue}
          id={OPTIMIZATION_GOAL + '_convert'}
          name={OPTIMIZATION_GOAL}
          value={CONVERT}
          selectedValue={values[OPTIMIZATION_GOAL]}
          label={t('Conversion')}
        >
          <p>{t('Select conversion event')}</p>
          <TikTokPixelAndEventFields formik={formik} />
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id={OPTIMIZATION_GOAL + '_click'}
          name={OPTIMIZATION_GOAL}
          value={CLICK}
          selectedValue={values[OPTIMIZATION_GOAL]}
          label={t('Clicks')}
        />

        {showBidField && (
          <CpaAdvancedSettings
            formik={formik}
            campaignObjective={campaignObjective}
            showBidField={showBidField}
            goalOptions={goalOptions}
          />
        )}
      </Step>
    )
  } else {
    return (
      <Step handleContinue={handleContinue}>
        <CpaAdvancedSettings
          formik={formik}
          campaignObjective={campaignObjective}
          showBidField={showBidField}
          goalOptions={goalOptions}
          isOptional={false}
          showInSpoiler={false}
        />
      </Step>
    )
  }
}

export default GoalsWithPixelAndEventStep
